import type { ComponentProps, FC } from 'react';
import { useController } from 'react-hook-form';

import { Checkbox } from '@catalyze/ui';

import { Label, Row } from './styled';

type ICheckboxRowProps = ComponentProps<typeof Row> & {
    value: string | null;
    label: string;
    inputName: string;
};

export const CheckboxRow: FC<ICheckboxRowProps> = ({
    value,
    label,
    inputName,
    ...props
}) => {
    const {
        field: { value: fieldValues, onChange },
    } = useController({ name: inputName });
    const createHandler = (value: string | null) => (checked: boolean) => {
        const values = fieldValues ?? [];
        if (checked) {
            onChange([...values, value]);
        } else {
            onChange(values?.filter((item: string) => item !== value));
        }
    };
    return (
        <Row {...props}>
            <Checkbox
                uniqueKey={value ?? 'null'}
                handleOnChange={createHandler(value)}
                checked={fieldValues?.includes(value)}
            />
            <Label htmlFor={value ?? 'null'}>{label}</Label>
        </Row>
    );
};

CheckboxRow.defaultProps = {};
